import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";
import {Role} from "./Role";
import _ = require('lodash');
import {Upload} from "./Upload";

export class Contract extends BaseModel {
	id: string
	title: string
	description: string
	number: string
	startDate: string
	endDate: string
	customerId: string
	uploads: Upload[]
}

export class ContractDescriptor extends BaseModelDescriptor{
	static id: AttributeDescriptor = {validation: []}
	static title: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static number: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static description: AttributeDescriptor = {validation: []}
	static startDate: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static endDate: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static customerId: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
}
